<template>
  <div>
    <InventoryPageHeader>
  <template #title>
    <router-link to="/devices" class="btn btn-sm btn-outline-secondary mr-2">
      <i class="fas fa-arrow-left"></i>
    </router-link>
    Company Details
  </template>
</InventoryPageHeader>

    <b-container fluid class="mt--6">
      <b-card no-body class="card-shadow mb-4">
        <b-card-header><i class="fas fa-building mr-2"></i>{{ name }}</b-card-header>
        <b-card-body><p><strong>Devices currently with this company:</strong> {{ devices.length }}</p></b-card-body>
      </b-card>

      <b-card no-body class="card-shadow">
        <b-card-header><i class="fas fa-tablet-alt mr-2"></i>Devices</b-card-header>
        <b-card-body class="p-0 table-responsive">
          <el-table :data="devices" @row-click="goToDevice" row-class-name="cursor-pointer" style="width:100%;">
            <el-table-column label="MAC">
              <template slot-scope="{ row }">
                <router-link :to="`/devices/${row.mac}`" class="text-primary font-weight-bold">{{ row.mac }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="{ row }">
                <b-badge :variant="row.currentStatus.startsWith('RMA') ? 'danger' : (row.currentStatus === 'OK' ? 'success' : 'secondary')">{{ row.currentStatus }}</b-badge>
              </template>
            </el-table-column>
            <el-table-column prop="batch" label="Batch" />
          </el-table>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InventoryPageHeader from '@/components/InventoryPageHeader.vue'

export default {
  name: 'CompanyDetail',
  components: { InventoryPageHeader },

  props: ['name'],
  computed: {
    ...mapGetters('inventory', ['devicesByCompany']),
    devices() { return this.devicesByCompany(this.name) }
  },
  mounted() {
    this.$store.dispatch('inventory/loadDevices')
  },
  methods: {
    goToDevice(row) {
      this.$router.push({ name: 'deviceDetail', params: { mac: row.mac } })
    }
  }
}
</script>